import React, {useEffect, useMemo, useState} from 'react';

import { throttle } from 'underscore';
import { fetchJson } from '../../../helpers/fetch.js';
import LoadingIndicator from '../../common/loading_indicator.jsx';
import ProjectPhasesBar from './ProjectPhasesBar.jsx';
import ProjectCard from '../../project_overview/components/ProjectCard.jsx';

import {
  project_phase_data_path,
  project_phase_step_to_path,
} from '~/routes';

function ProjectPhasesIndex({
  project_id= undefined,
  projectId: projectIdAlias,
  canManageProjectPhases = false,
  isContractModuleEnabled = false,
  context = '',
  settings = {}
}) {
  project_id = project_id ?? projectIdAlias;

  const [loading, setLoading] = useState(false);
  const [phases, setPhases] = useState(null);
  const [shownPhase, setShownPhase] = useState(null);
  const [invalidConfig, setInvalidConfig] = useState(false);

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      const data = await fetchJson(project_phase_data_path({project_id}));
      setPhases(data.phases);
      const currentPhase = data.phases?.find(p => p.current);
      setShownPhase(currentPhase || null);
      if (data.phases === null) {
        setInvalidConfig(true);
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  const step = async (phase_id) => {
    if (loading) return;
    setLoading(true);
    const data = await fetchJson(project_phase_step_to_path({project_id, phase_id}), {method: 'POST'});
    const currentPhase = data.phases.find(p => p.current);
    setPhases(data.phases);
    setShownPhase(currentPhase || null);
    setLoading(false);
  }

  const throttledStep = useMemo(() => throttle(step, 2000), []);

  if (!phases && !invalidConfig) {
    return <ProjectCard settings={settings}><LoadingIndicator /></ProjectCard>
  } else if (invalidConfig) {
    //return <p className='description'>{I18n.t('configuration_invalid_phases')}</p>
    return <></>
  }

  return (
    <ProjectCard settings={settings}>
      <ProjectPhasesBar
        context={context}
        project_id={project_id}
        phases={phases}
        setPhases={setPhases}
        shownPhase={shownPhase}
        setShownPhase={setShownPhase}
        onNextStep={throttledStep}
        canManageProjectPhases={canManageProjectPhases}
        isContractModuleEnabled={isContractModuleEnabled}
      />
    </ProjectCard>
  )
}

export default ProjectPhasesIndex;